export enum MimeTypes {
	DUAL = 'vbrick/conference-dual', // TS presently doesn't permit computed values, so can't use import
	FLV = 'video/flv',
	HLS = 'application/vnd.apple.mpegURL',
	MP4 = 'video/mp4'
}
